import Head from 'expo-router/head';

import AccountPage from '@fhs-legacy/frontend/src/pages/account';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function AccountRoute() {
  return (
    <>
      <Head>
        <title>My Account - Firehouse Subs</title>
      </Head>
      <AccountPage />
    </>
  );
}
